import React, { useState, useRef, useEffect, useLayoutEffect } from "react";

import "../../styles/events.css";
import { Helmet } from "react-helmet-async";


// Temporary data – replace with your real events later
const EVENTS_DATA = [
  {
    id: "e1",
    title: "Drone Tech Workshop & Expo 2025 ",
    description:
      "Hon’ble CM Dr. Mohan Yadav tested and appreciated our programmable drone technology MPCST Campus, Nehru Nagar, Bhopal",
      longDescription: "At DroneTech Workshop & Expo 2025, our programmable voice-controlled and gesture-controlled drones were personally tested by Hon’ble Chief Minister Dr. Mohan Yadav. His appreciation for our innovation and student-centric STEM approach was a proud milestone, reinforcing our mission to make advanced drone technology accessible to every learner.",
    mediaType: "video",                      // "image" or "video"
    media: "/review_videos/MP_DroneTech_Workshop_CM.mp4",      // or a .mp4 path
    pt:"/review_videos/PT_CM.jpeg",
    logo: "/logos/MP_sasan_logo.png",   // small logo
    logoName: "MPCST, MPSEDC, IIT Indore",
  },
  {
    id: "e2",
    title: "Featured in Leading Newspapers",
    description:
      "Recognized in the press for showcasing programmable drones to Hon’ble CM Dr. Mohan Yadav at DroneTech Expo 2025",
    longDescription:"Our innovative drone technology was highlighted in the news during the DroneTech Workshop & Expo 2025. The article covered the Hon’ble Chief Minister Dr. Mohan Yadav’s visit, where he emphasized the importance of drone adoption across all sectors and appreciated the state’s new drone policy. The feature also showcased PracVerse demonstrating indigenous programmable drones to the Chief Minister, marking a proud moment for our team and a strong recognition of our efforts in advancing drone-based education and innovation.",
    mediaType: "image",
    media: "/review_videos/Newspaper.jpeg",
    logo: "/logos/news_logo.jpg",
    logoName: "Patrika Newspaper",
  },
  {
    id: "e3",
    title: "Drone Tech Workshop & Expo 2025",
    description:
      "Recognized as young innovators and entrepreneurs by Dr. Jagannath Nayak, Director, CHESS, DRDO",
    longDescription: "PracVerse was honoured on stage by Dr. Jagannath Nayak, Director of CHESS, DRDO, for our contributions as young innovators and entrepreneurs. His address on India’s progress in anti-drone technology set the tone for a future where emerging tech becomes everyday reality. This recognition reaffirmed our commitment to empowering the next generation through meaningful, real-world STEM learning.",
    mediaType: "image",
    media: "/review_videos/MP_DroneTech_Award.jpeg",      // or a .mp4 path
    logo: "/logos/mpcst_logo.png",
    logoName: "Vigyan Bhawan Bhopal",
  },
  {
    id: "e4", 
    title: "MP Tech Growth Conclave 2.0",
    description:
      "Honoured and delighted to be a delegate at the MP Tech Growth Conclave for the Drone Round Table Conference.",
    longDescription: "We were honoured to be invited as official delegates at the Madhya Pradesh Tech Growth Conclave 2.0, organised by MPSeDC – State IT Center (Department of Science & Technology, Government of MP). The conclave brought together leaders, innovators, and policymakers to shape the future of technology and sustainable growth in India. It was an incredible opportunity to represent PracVerse, engage in meaningful discussions, and contribute to conversations around emerging tech. The insights, collaborations, and forward-looking vision shared at the event will directly fuel our mission of transforming real-world learning through drone and AI innovation.",
    mediaType: "image",
    media: "/review_videos/MP_Tech_Conclave_2.jpeg",      // or a .mp4 path
    logo: "/logos/mpsedc_logo.jpeg",
    logoName: "MPSEDC",
  },
  {
    id: "e5",
    title: "Drone Masterclass for Engineering & Tech Students",
    description:
      "From data analysis to AI–ML integration—advanced drone technology made simple",
    longDescription: "In our session “Drone Technology: Advancements & Data Analytics,” college students discovered how drones capture data, how analytics converts it into insights, and how AI–ML expands real-world applications. What began as a demonstration evolved into an engaging, high-level conversation with students eager to explore deeper technical questions about drone data, processing, and future innovations.",
    mediaType: "image",
    media: "/review_videos/college_vb.jpeg",      // or a .mp4 path
    logo: "/logos/mpcst_logo.png",
    logoName: "Vigyan Bhawan Bhopal",
  },
  {
    id: "e6",
    title: "Future-Tech Drone Workshop for School Students",
    description:
      "Drone and AI learning exposure for Class 3–12 cohorts from MP’s government and private schools",
      longDescription: "Over 100 young learners explored drones for the first time—flying them hands-on, coding them through voice and gesture control, and understanding how AI & ML power real-world drone applications. The excitement in their eyes and their curiosity-driven questions captured the true spirit of innovation we aim to ignite.",
    mediaType: "image",
    media: "/review_videos/school_vb.jpeg",
    logo: "/logos/mpcst_logo.png",
    logoName: "Vigyan Bhawan Bhopal",
  }
  // you can add more events here…
];





// Temporary workshop data – adjust with your real workshops
const WORKSHOPS_DATA = [
  {
    id: "w1",
    title: "Program Highlights",
    description:
      "Learn to assemble and understand the core components of a drone in this hands-on workshop.",
    longDescription: "abc",
    mediaType: "video",
    media: "/review_videos/PH_Beacon_school.mp4",
    pt:"/review_videos/PT_TBS.png",
    logo: "/logos/logo_tbs.jpg",
    logoName: "The Beacon School, Gurugoan",
  },
  {
    id: "w2",
    title: "Drone Workshop",
    description:
      "Explore how AI and ML are revolutionising drone capabilities and autonomy.",
    longDescription: "abc",
    mediaType: "video",
    media: "/review_videos/Workshop_RN_Podar.mp4",
    pt:"/review_videos/PT_RN.png",
    logo: "/logos/R.N_Podar_School_Logo.png",
    logoName: "R.N. Podar School, Mumbai",
  },
  {
    id: "w3",
    title: "Program Highlights",
    description:
      "Code your drone's flight path and actions using intuitive block-based interfaces.",
    longDescription: "abc",
    mediaType: "video",
    media: "/review_videos/PH_BPS.mp4",
    pt:"/review_videos/PT_BPS.png",
    logo: "/logos/logo_bps.jpeg",
    logoName: "Bharti Public School, Delhi",
  },
  {
    id: "w4",
    title: "Drone Workshop",
    description:
      "Capture stunning aerial footage and learn professional-quality shot design.",
    mediaType: "video",
    media: "/review_videos/Workshop_Laxman.mp4",
    pt:"/review_videos/PT_LPS.png",
    logo: "/logos/LPS_Logo.png",
    logoName: "Laxman Public School, Delhi",
  },
  {
    id: "w5",
    title: "Program Highlights",
    description:
      "Design and program autonomous drones for complex, real-world challenges.",
    mediaType: "image",
    media: "/review_videos/PH_MVJ.jpeg",
    logo: "/logos/MVJ_logo.png",
    logoName: "MVJ International School, Bangalore",
  },
  {
    id: "w6",
    title: "Drone Workshop",
    description:
      "Capture stunning aerial footage and learn professional-quality shot design.",
    mediaType: "video",
    media: "/review_videos/Workshop_Narayana.mp4",
    pt:"/review_videos/PT_Narayana.png",
    logo: "/logos/logo_nar.jpg",
    logoName: "Narayana E - Techno School, Bhopal",
  },
  {
    id: "w7",
    title: "Program Highlights",
    description:
      "Capture stunning aerial footage and learn professional-quality shot design.",
    mediaType: "video",
    media: "/review_videos/PH_EWS.mp4",
    pt:"/review_videos/PT_EWS.png",
    logo: "/logos/logo_ews.jpeg",
    logoName: "Eva World School, Mumbai",
  },
  {
    id: "w8",
    title: "Drone Workshop",
    description:
      "Master precise flying techniques using professional RC transmitters.",
    mediaType: "video",
    media: "/review_videos/Workshop_Rahul.mp4",
    pt:"/review_videos/PT_RIS.png",
    logo: "/logos/RIS_Logo.png",
    logoName: "Rahul International School, Mumbai",
  },
];











export default function EventPage() {
  
  const events = EVENTS_DATA;
  const PAGE_SIZE = 4;

  const [currentPage, setCurrentPage] = useState(0);
  const previewRef = useRef(null);

  const totalEvents = events.length;
  const totalPages = Math.ceil(totalEvents / PAGE_SIZE);

  // compute a "safe" start index so last page still has PAGE_SIZE cards
  const getPageStart = (pageIndex) => {
    if (totalEvents <= PAGE_SIZE) return 0; // fewer than 4 events => just show all

    const rawStart = pageIndex * PAGE_SIZE;
    const maxStart = totalEvents - PAGE_SIZE; // last possible full window

    return Math.min(rawStart, maxStart);
  };

  const start = getPageStart(currentPage);
  const visibleEvents = events.slice(start, start + PAGE_SIZE);

  const goNext = () => {
    setCurrentPage((p) => Math.min(p + 1, totalPages - 1));
  };

  const goPrev = () => {
    setCurrentPage((p) => Math.max(p - 1, 0));
  };

  const goToPage = (i) => setCurrentPage(i);

  // keep preview strip scrolled so the first card of the page is visible
  // useEffect(() => {
  //   const container = previewRef.current;
  //   if (!container) return;

  //   const firstIndex = getPageStart(currentPage);
  //   const target = container.querySelector(
  //     `[data-preview-index="${firstIndex}"]`
  //   );

  //   if (target) {
  //     target.scrollIntoView({
  //       behavior: "smooth",
  //       block: "nearest",
  //       inline: "start",
  //     });
  //   }
  // }, [currentPage, totalEvents]);

  useEffect(() => {
  const container = previewRef.current;
  if (!container) return;

  const firstIndex = getPageStart(currentPage);
  const target = container.querySelector(
    `[data-preview-index="${firstIndex}"]`
  );
  if (!target) return;

  // Only move the horizontal scroll of the preview strip,
  // without affecting the page scroll position.
  const containerRect = container.getBoundingClientRect();
  const targetRect = target.getBoundingClientRect();
  const deltaX = targetRect.left - containerRect.left;

  container.scrollTo({
    left: container.scrollLeft + deltaX,
    behavior: "smooth",
  });
}, [currentPage, totalEvents]);









    // ---------- WORKSHOPS STATE (6 at a time) ----------
  // ---------- WORKSHOPS STATE (page-based, 6 at a time) ----------
  const WORKSHOP_PAGE_SIZE = 6;

const [workshopPage, setWorkshopPage] = useState(0);

const totalWorkshops = WORKSHOPS_DATA.length;
const workshopTotalPages = Math.ceil(
  totalWorkshops / WORKSHOP_PAGE_SIZE
);

// ensure last page still shows a full window of 6
const getWorkshopPageStart = (pageIndex) => {
  if (totalWorkshops <= WORKSHOP_PAGE_SIZE) return 0;

  const rawStart = pageIndex * WORKSHOP_PAGE_SIZE;
  const maxStart = totalWorkshops - WORKSHOP_PAGE_SIZE;

  return Math.min(rawStart, maxStart);
};

const workshopStart = getWorkshopPageStart(workshopPage);

const visibleWorkshops = WORKSHOPS_DATA.slice(
  workshopStart,
  workshopStart + WORKSHOP_PAGE_SIZE
);

const goWorkshopNext = () => {
  setWorkshopPage((p) => Math.min(p + 1, workshopTotalPages - 1));
};

const goWorkshopPrev = () => {
  setWorkshopPage((p) => Math.max(p - 1, 0));
};

const goWorkshopToPage = (i) => {
  setWorkshopPage(i);
};
const workshopPreviewRef = useRef(null);

// useEffect(() => {
//   const container = workshopPreviewRef.current;
//   if (!container) return;

//   const firstIndex = getWorkshopPageStart(workshopPage);
//   const target = container.querySelector(
//     `[data-workshop-preview-index="${firstIndex}"]`
//   );

//   if (target) {
//     target.scrollIntoView({
//       behavior: "smooth",
//       block: "nearest",
//       inline: "start",
//     });
//   }
// }, [workshopPage, totalWorkshops]);

useEffect(() => {
  const container = workshopPreviewRef.current;
  if (!container) return;

  const firstIndex = getWorkshopPageStart(workshopPage);
  const target = container.querySelector(
    `[data-workshop-preview-index="${firstIndex}"]`
  );
  if (!target) return;

  const containerRect = container.getBoundingClientRect();
  const targetRect = target.getBoundingClientRect();
  const deltaX = targetRect.left - containerRect.left;

  container.scrollTo({
    left: container.scrollLeft + deltaX,
    behavior: "smooth",
  });
}, [workshopPage, totalWorkshops]);






// --- DETAIL MODAL STATE (shared by events & workshops) ---
const [detailModal, setDetailModal] = useState({
  type: null,   // "event" or "workshop"
  index: 0,     // index in the chosen list
  open: false,
});

// open from an event card
const openEventModal = (absoluteIndex) => {
  setDetailModal({
    type: "event",
    index: absoluteIndex,
    open: true,
  });
};

// open from a workshop card
const openWorkshopModal = (absoluteIndex) => {
  setDetailModal({
    type: "workshop",
    index: absoluteIndex,
    open: true,
  });
};

const closeDetailModal = () => {
  setDetailModal((prev) => ({ ...prev, open: false }));
};

// move to previous item inside whichever list we're in
const goDetailPrev = () => {
  setDetailModal((prev) => {
    if (!prev.open) return prev;
    const list =
      prev.type === "event" ? EVENTS_DATA : WORKSHOPS_DATA;
    const newIndex = Math.max(prev.index - 1, 0);
    return { ...prev, index: newIndex };
  });
};

// move to next item
const goDetailNext = () => {
  setDetailModal((prev) => {
    if (!prev.open) return prev;
    const list =
      prev.type === "event" ? EVENTS_DATA : WORKSHOPS_DATA;
    const newIndex = Math.min(prev.index + 1, list.length - 1);
    return { ...prev, index: newIndex };
  });
};

// convenience values for rendering the modal
const currentDetailList =
  detailModal.type === "event" ? EVENTS_DATA : WORKSHOPS_DATA;
const currentDetailItem =
  detailModal.open && currentDetailList[detailModal.index]
    ? currentDetailList[detailModal.index]
    : null;
const currentDetailTotal = currentDetailList.length;







  return (
    <>

    <Helmet>
  <title>Drone Events & Workshops – PracVerse</title>
  <link rel="icon" href="/favicon.ico" />
<link rel="shortcut icon" href="/favicon.ico" />
<link rel="apple-touch-icon" href="/favicon.ico" />

  <meta
    name="description"
    content="Explore PracVerse events and workshops – from school programs and college seminars to CSR-backed drone education and tech conclaves."
  />
  <link rel="canonical" href="https://www.pracverse.com/events" />

  <meta property="og:title" content="Drone Events & Workshops – PracVerse" />
  <meta
    property="og:description"
    content="Highlights of drone tech expos, workshops, school programs and CSR initiatives by PracVerse."
  />
  <meta property="og:url" content="https://www.pracverse.com/events" />
  <meta property="og:image" content="https://www.pracverse.com/images/og-events.jpg" />

  <script type="application/ld+json">
    {JSON.stringify({
      "@context": "https://schema.org",
      "@type": "ItemList",
      "name": "PracVerse Events & Workshops",
      "url": "https://www.pracverse.com/events",
      "itemListElement": EVENTS_DATA.map((evt, index) => ({
        "@type": "Event",
        "position": index + 1,
        "name": evt.title,
        "description": evt.longDescription || evt.description,
        "image": evt.media ? `https://www.pracverse.com${evt.media}` : undefined,
        "location": evt.logoName
          ? {
              "@type": "Place",
              "name": evt.logoName
            }
          : undefined
      }))
    })}
  </script>
</Helmet>



    <div className="Event-page">
      {/* HERO */}
      <section className="events-hero-section">
        <div className="events-hero-inner">
          <h1 className="events-hero-title">Events & Workshops</h1>
          <p className="events-hero-sub">
            {/* Discover our upcoming events and exclusive workshop highlights
            designed to improve your skills and knowledge. */}
            From transformative workshops to nationwide recognition — here’s everything unfolding at PracVerse
          </p>
        </div>
      </section>

      {/* FEATURED EVENTS */}
      <section className="events-featured-section">
        <div className="container events-featured-inner">
          <header className="events-featured-header">
            <h2 className="events-featured-title">Featured Events</h2>
          </header>

          <div className="events-grid">
            {/* {visibleEvents.map((evt) => ( */}
              {visibleEvents.map((evt, idx) => {
  const absoluteIndex = start + idx; // index in EVENTS_DATA

  return (
              <article className="event-card" key={evt.id}>
                {/* MEDIA (image or video or placeholder) */}
                <div className="event-media">
                  {evt.media ? (
                    evt.mediaType === "video" ? (
                      <video
                        className="event-media-video"
                        src={evt.media}
                        controls
                        muted
                        playsInline
                        poster={evt.pt}
                      />
                    ) : (
                      <img src={evt.media} alt={evt.title} />
                    )
                  ) : (
                    <div className="event-media-placeholder">
                      <div className="placeholder-icon" />
                    </div>
                  )}
                </div>

                {/* BODY */}
                <div className="event-body">
                  <h3 className="event-title">{evt.title}</h3>
                  <p className="event-desc">{evt.description}</p>

                  {/* LOGO ROW */}
                  {(evt.logo || evt.logoName) && (
                    <div className="event-meta-row">
                      {evt.logo && (
                        <img
                          src={evt.logo}
                          alt={evt.logoName || `${evt.title} logo`}
                          className="event-logo"
                        />
                      )}
                      {evt.logoName && (
                        <span className="event-logo-name">
                          {evt.logoName}
                        </span>
                      )}
                    </div>
                  )}

                  <div className="event-actions">
                    <button className="btn event-view-btn"
                    type="button"
                    onClick={() => openEventModal(absoluteIndex)}
                    >View More</button>
                  </div>
                </div>
              </article>
            )})}
          </div>
        </div>
      </section>





      {/* SCROLL PREVIEW STRIP */}
            {/* SCROLL PREVIEW STRIP */}
      <section
        className="events-preview-strip"
        aria-label="Events and workshops preview carousel"
      >
        {/* Left arrow */}
        <button
          type="button"
          tabIndex={-1}
          className="preview-arrow left"
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            goPrev();
          }}
          disabled={currentPage === 0}
        >
          ‹
        </button>

        {/* Scrollable row */}
        <div className="preview-window" ref={previewRef}>
          <div className="preview-track">
            {events.map((ev, idx) => {
              // Is this event currently in the visible 4-card window?
              const isActive = idx >= start && idx < start + PAGE_SIZE;

              // Natural page this event belongs to (0, 1, 2...)
              const pageIndex = Math.floor(idx / PAGE_SIZE);

              return (
                <button
                  key={ev.id}
                  type="button"
                  tabIndex={-1}
                  data-preview-index={idx}
                  className={`preview-card ${isActive ? "is-active" : ""}`}
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    goToPage(pageIndex);
                  }}
                >
                  <div className="preview-thumb">
                    {ev.mediaType === "video" ? (
                      <video src={ev.media} muted playsInline loop
                      poster={ev.pt && ev.pt !== "" ? ev.pt : ev.media} />
                    ) : (
                      <img src={ev.media} alt={ev.title} />
                    )}
                  </div>
                  <div className="preview-title">{ev.title}</div>
                </button>
              );
            })}
          </div>
        </div>

        {/* Right arrow */}
        <button
          type="button"
          tabIndex={-1}
          className="preview-arrow right"
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            goNext();
          }}
          disabled={currentPage === totalPages - 1}
        >
          ›
        </button>
      </section>

      {/* Clickable page indicator */}
      <div className="preview-page-indicator">
        {Array.from({ length: totalPages }).map((_, i) => (
          <button
            key={i}
            type="button"
            tabIndex={-1}
            className={`preview-dot-button ${
              currentPage === i ? "active" : ""
            }`}
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              goToPage(i);
            }}
          />
        ))}
      </div>









{/* ================= WORKSHOPS & PROGRAM HIGHLIGHTS ================= */}
<section className="workshops-section">
  <div className="container workshops-inner">
    <header className="workshops-header">
      <h2 className="workshops-title">Workshops & Program Highlights</h2>
    </header>

    {/* 6 at a time – typically 2 rows x 3 columns */}
    <div className="workshops-grid">
      {/* {visibleWorkshops.map((wk) => (  */}
{visibleWorkshops.map((wk, idx) => {
  const absoluteIndex = workshopStart + idx; // index in WORKSHOPS_DATA

  return (
        <article className="workshop-card" key={wk.id}>
          {/* MEDIA */}
          <div className="workshop-media">
            {wk.media ? (
              wk.mediaType === "video" ? (
                <video
                  className="workshop-media-video"
                  src={wk.media}
                  controls
                  muted
                  playsInline
                  poster={wk.pt}
                />
              ) : (
                <img src={wk.media} alt={wk.title} />
              )
            ) : (
              <div className="workshop-media-placeholder">
                <div className="placeholder-icon" />
              </div>
            )}
          </div>

          {/* BODY */}
          <div className="workshop-body">
            <h3 className="workshop-title">{wk.title}</h3>
            {/* <p className="workshop-desc">{wk.description}</p> */}

            {(wk.logo || wk.logoName) && (
              <div className="workshop-meta-row">
                {wk.logo && (
                  <img
                    src={wk.logo}
                    alt={wk.logoName || `${wk.title} logo`}
                    className="workshop-logo"
                  />
                )}
                {wk.logoName && (
                  <span className="workshop-logo-name">{wk.logoName}</span>
                )}
              </div>
            )}
{/* 
            <div className="workshop-actions">
              <button className="btn workshop-view-btn"
              type="button"
              onClick={() => openWorkshopModal(absoluteIndex)}
              >View More</button>
            </div> */}
          </div>
        </article>
      )})}
    </div>
  </div>
</section>


{/* ---------- WORKSHOPS PREVIEW STRIP (Browse All Workshops) ---------- */}
<div className="container workshops-preview-header-row">
  <h3 className="workshops-preview-heading">Browse All Workshops</h3>
</div>

<section
  className="container workshops-preview-strip"
  aria-label="Workshops and program highlights preview carousel"
>
  {/* Left arrow */}
  <button
    type="button"
    tabIndex={-1}
    className="preview-arrow left"
    onClick={(e) => {
      e.preventDefault();
      e.stopPropagation();
      goWorkshopPrev();
    }}
    disabled={workshopPage === 0}
    aria-label="Show previous workshops"
  >
    ‹
  </button>

  {/* Scrollable row */}
  <div className="preview-window" ref={workshopPreviewRef}>
    <div className="preview-track">
      {WORKSHOPS_DATA.map((wk, idx) => {
        const isInWindow =
          idx >= workshopStart &&
          idx < workshopStart + WORKSHOP_PAGE_SIZE;

        const pageIndex = Math.floor(idx / WORKSHOP_PAGE_SIZE);

        return (
          <button
            key={wk.id}
            type="button"
            tabIndex={-1}
            data-workshop-preview-index={idx}
            className={`preview-card ${isInWindow ? "is-active" : ""}`}
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              goWorkshopToPage(pageIndex);
            }}
          >
            <div className="preview-thumb">
              {wk.mediaType === "video" ? (
                // <video src={wk.media} muted playsInline loop />
                <video
    src={wk.media}
    muted
    playsInline
    loop
    poster={wk.pt && wk.pt !== "" ? wk.pt : wk.media}
  />
              ) : (
                <img src={wk.media} alt={wk.title} />
              )}
            </div>
            <div className="preview-title">{wk.title}</div>
          </button>
        );
      })}
    </div>
  </div>

  {/* Right arrow */}
  <button
    type="button"
    tabIndex={-1}
    className="preview-arrow right"
    onClick={(e) => {
      e.preventDefault();
      e.stopPropagation();
      goWorkshopNext();
    }}
    disabled={workshopPage === workshopTotalPages - 1}
    aria-label="Show next workshops"
  >
    ›
  </button>
</section>

{/* Page dots for workshop strip */}
<div className="preview-page-indicator workshops-indicator">
  {Array.from({ length: workshopTotalPages }).map((_, i) => (
    <button
      key={i}
      type="button"
      tabIndex={-1}
      className={`preview-dot-button ${
        workshopPage === i ? "active" : ""
      }`}
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        goWorkshopToPage(i);
      }}
    />
  ))}
</div>








{/* ========= DETAIL MODAL (Events + Workshops) ========= */}
{detailModal.open && currentDetailItem && (
  <div className="detail-modal-backdrop">
    <div
      className="detail-modal"
      role="dialog"
      aria-modal="true"
      aria-label={
        detailModal.type === "event"
          ? "Event details"
          : "Workshop details"
      }
    >
      {/* Top bar: pagination + close */}
      <div className="detail-modal-top">
        <div className="detail-top-left">
          <button
            type="button"
            className="detail-nav-icon"
            onClick={goDetailPrev}
            disabled={detailModal.index === 0}
          >
            ‹
          </button>

          <div className="detail-counter">
            {detailModal.index + 1} / {currentDetailTotal}
          </div>

          <button
            type="button"
            className="detail-nav-icon"
            onClick={goDetailNext}
            disabled={detailModal.index === currentDetailTotal - 1}
          >
            ›
          </button>

          
        </div>
        <button
            type="button"
            className="detail-close-icon"
            onClick={closeDetailModal}
            aria-label="Close"
          >
            ✕
          </button>
      </div>

      {/* Title */}
      <h2 className="detail-modal-title">
        {currentDetailItem.title}
      </h2>

      {/* Main content */}
      <div className="detail-modal-body">
        {/* One main media block only */}
        <div className="detail-modal-media">
          {currentDetailItem.mediaType === "video" ? (
            <video
              src={currentDetailItem.media}
              controls
              playsInline
              muted
            />
          ) : (
            <img
              src={currentDetailItem.media}
              alt={currentDetailItem.title}
            />
          )}
        </div>

        {/* Logo + location line (replaces location pin) */}
        {(currentDetailItem.logo || currentDetailItem.logoName) && (
          <div className="detail-modal-meta-row">
            {currentDetailItem.logo && (
              <img
                src={currentDetailItem.logo}
                alt={
                  currentDetailItem.logoName ||
                  `${currentDetailItem.title} logo`
                }
                className="detail-modal-logo"
              />
            )}
            {currentDetailItem.logoName && (
              <span className="detail-modal-location">
                {currentDetailItem.logoName}
              </span>
            )}
          </div>
        )}

        {/* Long description – fall back to short if you don't have a separate field */}
        <p className="detail-modal-description">
          {currentDetailItem.longDescription ||
            currentDetailItem.description}
        </p>
      </div>

      {/* Bottom buttons */}
      <div className="detail-modal-footer">
        <button
          type="button"
          className="detail-footer-btn secondary"
          onClick={goDetailPrev}
          disabled={detailModal.index === 0}
        >
          ‹ Previous
        </button>

        <button
          type="button"
          className="detail-footer-btn primary"
          onClick={closeDetailModal}
        >
          Close
        </button>

        <button
          type="button"
          className="detail-footer-btn secondary"
          onClick={goDetailNext}
          disabled={detailModal.index === currentDetailTotal - 1}
        >
          Next ›
        </button>
      </div>
    </div>
  </div>
)}


      
    </div>
    </>
  );
}
